module.exports = __webpack_public_path__ + "img/hero-background-darker.a0265840.jpg";